import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../common/FormContainer";
import CheckoutSteps from "../common/CheckoutSteps";
import Meta from "../common/Meta";
import { saveDeliveryAddress } from "../../actions/bookingActions";

const DeliveryScreen = () => {
  const navigate = useNavigate();
  const booking = useSelector((state) => state.booking);
  const { deliveryAddress } = booking;

  const [fullName, setFullName] = useState(deliveryAddress.fullName);
  const [phone, setPhone] = useState(deliveryAddress.phone);
  const [address, setAddress] = useState(deliveryAddress.address);
  const [city, setCity] = useState(deliveryAddress.city);

  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(saveDeliveryAddress({ fullName, phone, address, city }));
    navigate("/payment");
  };

  return (
    <>
      <Meta title="Delivery details" />
      <FormContainer>
        <CheckoutSteps step1 step2 />
        <h1>Delivery details</h1>
        <Form onSubmit={submitHandler}>
          <Form.Group controlId="fullName">
            <Form.Label>Full name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Full name"
              value={fullName}
              required
              onChange={(e) => setFullName(e.target.value)}
            ></Form.Control>
          </Form.Group>
          <Form.Group controlId="phone">
            <Form.Label>Phone no</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter phone"
              value={phone}
              required
              onChange={(e) => setPhone(e.target.value)}
            ></Form.Control>
          </Form.Group>
          <Form.Group controlId="address">
            <Form.Label>Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter address"
              value={address}
              required
              onChange={(e) => setAddress(e.target.value)}
            ></Form.Control>
          </Form.Group>
          <Form.Group controlId="city">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter city"
              value={city}
              required
              onChange={(e) => setCity(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Button type="submit" variant="primary" className="my-2">
            Continue
          </Button>
        </Form>
      </FormContainer>
    </>
  );
};

export default DeliveryScreen;
